import type * as Sentry from '@sentry/react'
import { isNetworkError } from 'utils/js'

import {
  SentryFilterTagOneClickUpgradeButton,
  SentryFilterTagOneClickUpgradeToggle,
  SentryFilterTagOneClickYearlyExtension,
  SentryFilterTagPaymentsDialog,
  SentryFilterTagPaymentsButton,
  SentryFilterTagAutostartFreeTrial,
  SentryFilterCoinsTopUp,
} from './constants'

const sentryPaymentTags = new Set([
  SentryFilterTagPaymentsButton,
  SentryFilterTagPaymentsDialog,
  SentryFilterTagOneClickUpgradeButton,
  SentryFilterTagOneClickUpgradeToggle,
  SentryFilterTagOneClickYearlyExtension,
  SentryFilterTagAutostartFreeTrial,
  SentryFilterCoinsTopUp,
])

/**
 * Check if the user is offline. Only drop network errors when we're confident
 * it's a client-side issue, not a server problem.
 */
function isUserOffline(): boolean {
  return typeof navigator !== 'undefined' && navigator.onLine === false
}

export function beforeSend(
  event: Sentry.ErrorEvent,
  hint: Sentry.EventHint,
): Sentry.ErrorEvent | PromiseLike<Sentry.ErrorEvent | null> | null {
  const error = hint?.originalException

  // Only drop network errors if the user is offline
  // If user is online but we get a network error, it could be a server issue
  if (isNetworkError(error) && isUserOffline()) {
    return null
  }

  return event
}

export function beforeSendPayments(
  event: Sentry.ErrorEvent,
  hint: Sentry.EventHint,
): Sentry.ErrorEvent | PromiseLike<Sentry.ErrorEvent | null> | null {
  const nextEvent = beforeSend(event, hint)
  if (!nextEvent) {
    return null
  }

  if (event.tags?.component && sentryPaymentTags.has(event.tags.component as string)) {
    return event
  }

  return null
}
